import React, { Component } from 'react';
import autoBind from 'react-autobind';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { ButtonColors } from 'src/utils/constants';
import { withTranslation } from 'react-i18next';
import composeModalActions from 'src/utils/modal-action-wrapper';
import { Entities } from 'src/common';
import TableHelper from 'src/utils/table-helper';
import { priceFormatter } from 'src/utils/formatters';
import ConfirmDialog from 'src/components/misc/confirm-dialog';
import SimpleTableSkeleton from 'src/components/skeleton/simple-table-skeleton';
import ZoneCalculationAdministrationModal from 'src/components/administration/zone-calculation/components/zone-calculation-administration-modal';

class ZoneCalculationAdministrationItems extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.tableHelper = new TableHelper();
    }
    render() {
        const { t, zoneCalculations } = this.props;

        const tableData = [];

        const finishFetching = !zoneCalculations.isFetching;
        if (!finishFetching) return <SimpleTableSkeleton onlyTable={true} />;

        if (finishFetching) {
            zoneCalculations.items.map(item => {
                tableData.push({
                    ...item,
                    zoneAName: item.zoneA.name,
                    zoneBName: item.zoneB ? item.zoneB.name : '-',
                });
            });
        }

        return (
            <>
                <BootstrapTableErrorBoundary>
                    <BootstrapTable
                        ref={ref => (this.table = ref)}
                        data={tableData}
                        exportCSV={true}
                        striped={true}
                        hover={true}
                        condensed={true}
                        pagination={true}
                        options={Object.assign(this.tableHelper.getOptions(finishFetching))}
                        selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                        searchPlaceholder={t('common_phrases.search')}
                        search={true}>
                        <TableHeaderColumn columnTitle={true} dataField="id" hidden={true} isKey={true} export={true}>
                            {t('common_phrases.id')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} dataField="name" width="180" dataSort={true}>
                            {t('common_phrases.name')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} dataField="zoneAName" dataSort={true}>
                            {t('zone_calculation.table.zone_a')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} dataField="zoneBName" dataSort={true}>
                            {t('zone_calculation.table.zone_b')}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            width="80"
                            columnTitle={true}
                            dataField="maxAmountIntermediates"
                            dataSort={true}>
                            {t('zone_calculation.table.max_amount_intermediates')}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            width="120"
                            columnTitle={true}
                            dataField="flatRate"
                            dataFormat={priceFormatter}
                            dataSort={true}>
                            {t('zone_calculation.table.flat_rate')}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="active"
                            width="80"
                            dataAlign="center"
                            dataSort={true}
                            dataFormat={this.toggleFormatter}>
                            {t('common_phrases.active')}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="actions"
                            width="120"
                            dataFormat={this.tableActionsFormatter}
                            export={false}>
                            {t('common_phrases.actions')}
                        </TableHeaderColumn>
                    </BootstrapTable>
                </BootstrapTableErrorBoundary>
            </>
        );
    }

    tableActionsFormatter(cell, calculation) {
        const { t } = this.props;
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    title={t('user_functionality.delete')}
                    onClick={() => {
                        this.openConfirmDeleteDialog(calculation);
                    }}>
                    <span className="glyphicon glyphicon-trash text-danger" />
                </button>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    title={t('user_functionality.edit')}
                    onClick={() => {
                        if (this.table) this.table.reset();
                        this.props.openModal({
                            component: ZoneCalculationAdministrationModal,
                            componentProps: {
                                isCreate: false,
                                geofenceAreas: this.props.geofenceAreas,
                                geoZoneCalculation: calculation,
                                onSubmit: this.props.handleSubmit,
                                selectedCountryCalc: this.props.selectedCountryCalc,
                                busCompany: this.props.busCompany,
                                addNotification: this.props.addNotification,
                            },
                            title: t('zone_calculation.modal.edit.title'),
                            mandatoryFields: true,
                        });
                    }}>
                    <span className="glyphicon glyphicon-pencil text-info" />
                </button>
            </div>
        );
    }

    openConfirmDeleteDialog(calculation) {
        const { t } = this.props;
        if (this.table) this.table.reset();
        this.props.openModal({
            component: ConfirmDialog,
            componentProps: {
                event: calculation,
                onProceedDialog: this.onProceedDelete,
                bodyText: t('zone_calculation.modal.delete.body'),
                proceedText: t('user_functionality.delete'),
                cancelText: t('common_phrases.no'),
                cancelButtonColor: ButtonColors.NOTIFY,
                proceedButtonColor: ButtonColors.DANGER,
            },
            title: calculation.name,
            noButtons: true,
        });
    }

    onProceedDelete(calculation) {
        if (calculation) this.props.deleteById(calculation.id, Entities.ZONE_CALCULATION, this.props.selectedCompany);
    }
}

export default withTranslation()(composeModalActions(ZoneCalculationAdministrationItems));
